exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".trans{-webkit-transition:-webkit-transform .2s ease;transition:-webkit-transform .2s ease;transition:transform .2s ease;transition:transform .2s ease,-webkit-transform .2s ease}.sider-trigger-a{padding:6px;width:40px;height:40px;display:inline-block;text-align:center;color:#5c6b77;margin-top:12px}.sider-trigger-a i{vertical-align:top}.sider-trigger-a.collapsed i,.sider-trigger-a i{-webkit-transition:-webkit-transform .2s ease;transition:-webkit-transform .2s ease;transition:transform .2s ease;transition:transform .2s ease,-webkit-transform .2s ease}.sider-trigger-a.collapsed i{-webkit-transform:rotate(90deg);transform:rotate(90deg)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-77f08f94","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/iview-loader??ref--0-1!./src/view/main/components/side-menu/sider-trigger/sider-trigger.vue
// module id = D5Zu
// module chunks = 131